import React from 'react'
import VsRatingBar from '../UI/VsRatingBar';
import classes from "./ScoreBoardB.module.css"

type ScoreBoardProps = {
  shield?: number,
  hp ?: number,
  gas?: number,
  mechVar?: number,
  rankVar?: number
}

const ScoreBoardB:React.FC<ScoreBoardProps> = ({shield, hp, gas, mechVar, rankVar}) => {
  return (
    <div className={classes["score-board-b-root"]}>
      <div className={classes["score-board-b-var"]}>
        <div>{mechVar}</div>
        <div>{rankVar}</div>
      </div>
      <div className={classes["score-board-b-inner"]}>
        <VsRatingBar name="Shield" rating={shield} />
        <VsRatingBar name="Hp" rating={hp} />
        <VsRatingBar name="Gas" rating={gas} />
      </div>
    </div>
  );
}

export default ScoreBoardB